import { render, staticRenderFns } from "./IconMenu.vue?vue&type=template&id=47607339&scoped=true&"
import script from "./IconMenu.vue?vue&type=script&lang=js&"
export * from "./IconMenu.vue?vue&type=script&lang=js&"
import style0 from "./IconMenu.vue?vue&type=style&index=0&id=47607339&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47607339",
  null
  
)

export default component.exports